import ReactECharts from "echarts-for-react";

export default function ChartLead({ chartData }) {
  const mo = chartData?.mo ?? [];
  const tls = chartData?.tls ?? [];
  const sales = chartData?.sales ?? [];
  const organizationType = chartData?.organizationType ?? [];
  const statusLead = chartData?.statusLead ?? [];
  const spkStatus = chartData?.spkStatus ?? [];
  const leadSource = chartData?.leadSource ?? [];
  const sourceCompanyLeads = chartData?.sourceCompanyLeads ?? [];
  const productCategory = chartData?.productCategory ?? [];
  const clickPlan = chartData?.clickPlan ?? [];

  const optionMonthly = {
    title: { text: "Jumlah Leads MO", left: "center" },
    tooltip: { trigger: "axis" },
    grid: { top: 50, bottom: 50, left: 60, right: 30 },
    xAxis: {
      type: "category",
      data: mo.map((d) => d.mo),
      axisLabel: {
        interval: 0,
        formatter: function (value) {
          return value.length > 7 ? value.slice(0, 7) + "..." : value;
        },
      },
    },
    yAxis: { type: "value" },
    series: [
      {
        type: "bar",
        data: mo.map((d) => d.total),
        itemStyle: {
          color: (params) => {
            const colors = [
              "#ef4444",
              "#f59e0b",
              "#22c55e",
              "#3b82f6",
              "#a855f7",
            ];
            return colors[params.dataIndex % colors.length];
          },
          borderRadius: [6, 6, 0, 0],
        },
      },
    ],
  };

  const optionStatus = {
    title: { text: "Status Leads", left: "center", top: 6 },
    tooltip: {
      trigger: "item",
      formatter: ({ name, value, percent }) =>
        `${name}<br/>${value} (${percent}%)`,
    },
    legend: { type: "scroll", orient: "vertical", right: 0, top: "middle" },
    series: [
      {
        type: "pie",
        radius: ["22%", "42%"],
        center: ["35%", "48%"],
        avoidLabelOverlap: false,
        minShowLabelAngle: 0,
        labelLayout: { hideOverlap: false, moveOverlap: "shiftY" },
        label: {
          show: true,
          position: "outside",
          alignTo: "labelLine",
          distanceToLabelLine: 4,
          width: 120,
          overflow: "truncate",
          formatter: ({ name, percent }) => {
            const n = name?.length > 18 ? name.slice(0, 18) + "…" : name;
            return `${n}\n${Math.round(percent)}%`;
          },
          fontSize: 9,
          fontWeight: "bold",
          color: "#111",
        },
        labelLine: { show: true, length: 10, length2: 8 },
        itemStyle: { borderRadius: 6, borderColor: "#fff", borderWidth: 2 },
        data: statusLead,
        // color: [
        //   "#3b82f6",
        //   "#f59e0b",
        //   "#22c55e",
        //   "#ef4444",
        //   "#a855f7",
        //   "#06b6d4",
        //   "#84cc16",
        // ],
      },
    ],
  };

  const optionOrganizationType = {
    title: { text: "Pemerintah/Swasta", left: "center" },
    tooltip: { trigger: "item" },
    legend: { bottom: 0 },
    series: [
      {
        type: "pie",
        radius: ["30%", "50%"],
        label: { show: true, formatter: "{b}\n{d}%" },
        data: (organizationType || []).map((d) => ({
          name: d.organization_type,
          value: Number(d.value) || 0,
        })),
      },
    ],
  };

  const optionTopProducts = {
    title: {
      text: "Jumlah Lead Sales",
      left: "center",
      top: 10,
      textStyle: {
        fontSize: 16,
        fontWeight: "bold",
      },
    },
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
      formatter: "{b}: {c}",
    },
    grid: {
      left: "25%",
      right: "10%",
      bottom: "5%",
      top: "15%",
    },
    xAxis: {
      type: "value",
      axisLabel: { color: "#555" },
    },
    yAxis: {
      type: "category",
      data: sales.map((p) => p.sales),
      axisLabel: {
        color: "#555",
        fontSize: 9,
        formatter: function (value) {
          return value.length > 7 ? value.slice(0, 7) + "..." : value;
        },
      },
      inverse: true,
    },
    series: [
      {
        type: "bar",
        data: sales.map((v) => v.total),
        barWidth: 30,
        itemStyle: {
          borderRadius: [0, 6, 6, 0],
          color: function (params) {
            const colors = [
              "#4f46e5",
              "#22c55e",
              "#ef4444",
              "#f59e0b",
              "#06b6d4",
              "#ec4899",
              "#8b5cf6",
              "#10b981",
              "#f97316",
              "#3b82f6",
            ];
            return colors[params.dataIndex % colors.length];
          },
        },
        label: {
          show: true,
          position: "right",
          color: "#333",
          fontWeight: "bold",
        },
      },
    ],
  };

  const optionLineChart = {
    title: {
      text: "Proses Leads",
      left: "center",
      top: 10,
      textStyle: {
        fontSize: 16,
        fontWeight: "bold",
      },
    },
    tooltip: {
      trigger: "axis",
    },
    grid: {
      left: "10%",
      right: "5%",
      bottom: "10%",
      top: "20%",
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: spkStatus.map((val) => val.spk_status),
      axisLine: { lineStyle: { color: "#888" } },
      axisLabel: { color: "#555" },
    },
    yAxis: {
      type: "value",
      axisLine: { lineStyle: { color: "#888" } },
      axisLabel: { color: "#555" },
      splitLine: { lineStyle: { color: "#eee" } },
    },
    series: [
      {
        name: "Jumlah Leads",
        type: "line",
        smooth: true,
        data: spkStatus.map((val) => val.total),
        symbol: "circle",
        symbolSize: 8,
        itemStyle: {
          color: "#4f46e5",
        },
        lineStyle: {
          width: 3,
          color: "#4f46e5",
        },
        areaStyle: {
          color: "rgba(79, 70, 229, 0.2)",
        },
        emphasis: {
          focus: "series",
        },
      },
    ],
  };

  const optionNightingale = {
    title: { text: "Jumlah Leads TLS", left: "center" },
    tooltip: { trigger: "axis" },
    grid: { top: 50, bottom: 50, left: 60, right: 30 },
    xAxis: {
      type: "category",
      data: tls.map((d) => d.tls),
      axisLabel: {
        interval: 0,
        rotate: 30,
        formatter: function (value) {
          return value.length > 7 ? value.slice(0, 7) + "..." : value;
        },
      },
    },
    yAxis: { type: "value" },
    series: [
      {
        type: "bar",
        data: tls.map((d) => d.total),
        itemStyle: {
          color: (params) => {
            const colors = [
              "#ef4444",
              "#f59e0b",
              "#22c55e",
              "#3b82f6",
              "#a855f7",
            ];
            return colors[params.dataIndex % colors.length];
          },
          borderRadius: [6, 6, 0, 0],
        },
      },
    ],
  };

  const optionLeadSource = {
    title: { text: "Sumber Leads", left: "center" },
    tooltip: { trigger: "item" },
    legend: { bottom: 0 },
    series: [
      {
        type: "pie",
        radius: ["15%", "30%"],
        center: ["55%", "50%"],

        label: {
          show: true,
          position: "outside",
          formatter: "{b}\n{d}%",
          fontSize: 9,
        },
        labelLine: {
          show: true,
          length: 15,
          length2: 10,
        },

        data: (leadSource || []).map((d) => ({
          name: d.lead_source,
          value: Number(d.total) || 0,
        })),
      },
    ],
  };

  const SumberLeadsChart = {
    title: {
      text: "Sumber Leads Perusahaan",
      left: "center",
      top: 10,
      textStyle: {
        fontWeight: "bold",
        fontSize: 16,
      },
    },
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
    },
    grid: {
      left: 40,
      right: 20,
      bottom: 60,
      top: 60,
    },
    xAxis: {
      type: "category",
      name: "",
      data: sourceCompanyLeads.map((v) => v.company),
      axisLabel: {
        interval: 0,
        rotate: 45,
      },
    },
    yAxis: {
      type: "value",
      name: "Jumlah Perusahaan",
      nameLocation: "middle",
      nameGap: 30,
    },
    series: [
      {
        type: "bar",
        data: sourceCompanyLeads.map((v) => v.total),
        label: {
          show: true,
          position: "top",
          fontSize: 9,
        },
        barWidth: "50%",
      },
    ],
  };

    const optionProductCategory = {
    title: { text: "Leads Per Kategori", left: "center" },
    tooltip: { trigger: "item" },
    legend: { show: false },
    series: [
      {
        type: "pie",
        radius: ["0%", "30%"],
        center: ["55%", "50%"],

        label: {
          show: true,
          position: "outside",
          formatter: "{b}\n{d}%",
          fontSize: 9,
        },
        labelLine: {
          show: true,
          length: 15,
          length2: 10,
        },

        data: (productCategory || []).map((d) => ({
          name: d.category_name,
          value: Number(d.total) || 0,
        })),
      },
    ],
  };

    const optionClickPlan = {
    title: { text: "Sumber Leads", left: "center" },
    tooltip: { trigger: false },
    legend: { show: false },
    series: [
      {
        type: "pie",
        radius: ["15%", "30%"],
        center: ["55%", "50%"],

        label: {
          show: true,
          position: "outside",
          formatter: "{b}\n{d}%",
          fontSize: 9,
        },
        labelLine: {
          show: true,
          length: 15,
          length2: 10,
        },

        data: (clickPlan || []).map((d) => ({
          name: d.month_name,
          value: Number(d.total) || 0,
        })),
      },
    ],
  };

  return (
    <div
      className="dashboard-grid"
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gridTemplateRows: "repeat(2, auto)",
        gap: "1.5rem",
      }}
    >
      {/* Baris 1, Kolom 1 */}
      <div className="card shadow-sm border" style={{ borderWidth: "3px" }}>
        <div className="card-body">
          <ReactECharts option={optionMonthly} style={{ height: 300 }} />
        </div>
      </div>

      {/* Baris 1, Kolom 2–3 (melebar 2 kolom) */}
      <div className="card shadow-sm border" style={{ borderWidth: "3px" }}>
        <div className="card-body">
          <ReactECharts option={optionNightingale} style={{ height: 300 }} />
        </div>
      </div>

      {/* Kolom 4, memanjang 2 baris */}
      <div
        className="card shadow-sm border"
        style={{
          borderWidth: "3px",
          gridColumn: "4",
          gridRow: "1 / span 2",
        }}
      >
        <div className="card-body">
          <ReactECharts option={optionTopProducts} style={{ height: 640 }} />
        </div>
      </div>

      {/* Baris 2, Kolom 1 */}
      <div className="card shadow-sm border" style={{ borderWidth: "3px" }}>
        <div className="card-body">
          <ReactECharts option={optionStatus} style={{ height: 300 }} />
        </div>
      </div>

      {/* Baris 2, Kolom 2 */}
      <div className="card shadow-sm border" style={{ borderWidth: "3px" }}>
        <div className="card-body">
          <ReactECharts
            option={optionOrganizationType}
            style={{ height: 300 }}
          />
        </div>
      </div>

      {/* Baris 2, Kolom 3 */}
      <div
        className="card shadow-sm border"
        style={{
          borderWidth: "3px",
          gridColumn: "2 / span 2",
          gridRow: "1",
        }}
      >
        <div className="card-body">
          <ReactECharts option={optionLineChart} style={{ height: 300 }} />
        </div>
      </div>

      {/* Baris 2, Kolom 3 */}
      <div
        className="card shadow-sm border"
        style={{
          borderWidth: "3px",
          gridColumn: "1",
          gridRow: "3",
        }}
      >
        <div className="card-body">
          <ReactECharts
            option={optionLeadSource}
            style={{ height: 340, paddingTop: 20 }}
          />
        </div>
      </div>
      <div
        className="card shadow-sm border"
        style={{
          borderWidth: "3px",
          gridColumn: "2",
          gridRow: "3",
        }}
      >
        <div className="card-body">
          <ReactECharts
            option={SumberLeadsChart}
            style={{ height: 340, paddingTop: 20 }}
          />
        </div>
      </div>
      <div
        className="card shadow-sm border"
        style={{
          borderWidth: "3px",
          gridColumn: "3",
          gridRow: "3",
        }}
      >
        <div className="card-body">
          <ReactECharts
            option={optionProductCategory}
            style={{ height: 340, paddingTop: 20 }}
          />
        </div>
      </div>
      <div
        className="card shadow-sm border"
        style={{
          borderWidth: "3px",
          gridColumn: "4",
          gridRow: "3",
        }}
      >
        <div className="card-body">
          <ReactECharts
            option={optionClickPlan}
            style={{ height: 340, paddingTop: 20 }}
          />
        </div>
      </div>
    </div>
  );
}
